<script setup>
import { inject } from 'vue'

const props = defineProps({
  label: String,
  disabled: Boolean,
  padding: String,
  labelColor: String,
  bgColor: { type: String, default: '#1F47CD' },
  bgHover: { type: String, default: '#007BFF' },
  to: String
})
const { global } = inject('Shared')

defineEmits(['clicked'])
</script>

<template lang='pug'>
component.appBtn(
  @click.prevent.stop="$emit('clicked')"
  :class="disabled ? 'disabledBtn' : ''"
  :is="to ? 'router-link' : 'div'"
  :to="to"
  :style="`color: ${labelColor ? labelColor: 'white' }`"
) {{ label }}
</template>

<style scoped lang='sass'>
.appBtn
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  padding: v-bind(padding)
  min-height: 50px
  cursor: pointer
  border-radius: v-bind('global.buttonBorderRadius')
  transition: background-color 0.3s ease
  background: v-bind(bgColor)
  border: v-bind(border)
  text-decoration: none !important
  font-weight: 600
  @media screen and (min-width: 600px)
    font-size: 20px
  @media screen and (max-width: 599px)
    text-align: center
    font-size: 16px
  &:hover
    background: v-bind(bgHover)
.disabledBtn
  cursor: not-allowed
</style>
